import { FormProvider } from 'react-hook-form';
import { Outlet } from 'react-router-dom';
import styles from './FormBuilderLayout.module.css';
import { useFormBuilderSubmit } from './hooks/useFormBuilderSubmit';
import { useFormBuilderTemplate } from './hooks/useFormBuilderTemplate';
import { Loader } from '@/components/Loader';
import { useSubmitGuard } from '@/hooks/useSubmitGuard';
import { preventImplicitSubmit } from '@/utils/preventImplicitSubmit';

/**
 * Layout for the form builder pages: provides the template form and submits it on Publish.
 * A repeated submit while the template is being published is ignored, and Enter in a field
 * does not submit it.
 * @returns The form builder layout.
 */
export const FormBuilderLayout = () => {
  const { loading, methods } = useFormBuilderTemplate();
  const { onSubmit, onError } = useFormBuilderSubmit();
  const guardedSubmit = useSubmitGuard(methods.handleSubmit(onSubmit, onError));

  if (loading) return <Loader full />;

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={guardedSubmit}
        onKeyDown={preventImplicitSubmit}
        className={styles.container}
        aria-label="form"
      >
        <Outlet />
      </form>
    </FormProvider>
  );
};
